import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const selectors = {
    el: '.js-scrolling-sections:not(.is-ready)',
    content: '.js-scrolling-sections__content',
    section: '.js-scrolling-sections__section',
    anchor: '.js-scrolling-sections__anchor'
};

const classes = {
    active: 'is-active'
}

const build = el => {
    el.classList.add('is-ready');
    el.style.height = el.offsetHeight + 'px';
    const content = el.querySelector(selectors.content);
    content.style.height = '100vh';

    const sections = [...content.querySelectorAll(selectors.section)];
    const sectionHeight = sections[0].offsetHeight;
    const fraction = 1 / sections.length;
    let prevIdx = 0;

    const anchors = [...el.querySelectorAll(selectors.anchor)];
    anchors.forEach(anchor => {
        anchor.addEventListener('click', e => {
            e.preventDefault();
            const section = content.querySelector(selectors.section + e.target.hash);
            if (!section) return;
            const idx = sections.indexOf(section);
            scrollToSection(idx);
        });
    });

    gsap.from(content, {
        scrollTrigger: {
            trigger: el,
            start: 'top top',
            end: `bottom ${window.innerHeight - 1}`,
            onUpdate: self => {
                const idx = Math.floor(self.progress / fraction);
                const section = sections[idx];
                if (idx === prevIdx || !section) return;
                sections.forEach(section => section.classList.remove(classes.active));
                anchors.forEach(anchor => anchor.classList.remove(classes.active));
                if (section) {
                    content.scrollTo(0, section.offsetTop);
                    section.classList.add(classes.active);
                    const activeAnchor = anchors.find(anchor => anchor.href.split('#')[1] === section.id);
                    activeAnchor.classList.add(classes.active);
                }
                prevIdx = idx;
            }
        }
    });

    const scrollToSection = idx => {
        const scrollDistance = el.offsetTop + idx * sectionHeight;
        window.scrollTo({ top: scrollDistance, left: 0, behavior: 'instant' });
    }
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(build);
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;